export const processStatesColors = {
  TERMINATED: 'red',
  COMPLETED: 'green',
  WAITING: 'yellow',
  ACTIVE: 'blue',
};

export const processStatesLabels = {
  'TERMINATED': 'Terminé avec erreur',
  'COMPLETED': 'Terminé sans erreur',
  'WAITING': 'Dans la file d\'attente',
  'ACTIVE': 'En cours de traitement',
  'NONE': 'Aucune passerelle',
}
